<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card :title="`Company Groups (${company.name})`">
    <vs-progress v-if="!loaded" indeterminate color="primary"></vs-progress>
    <div v-else class="vx-row mb-2 px-2 flex items-center justify-between">
      <div  v-for="item in workingGroups" :key="item.id"
           class="sm:w-1/2 w-full py-1">
        <vs-checkbox v-model="item.isSelected" @input="updateCompanyGroup(item)">
          {{ item.division_name }}
        </vs-checkbox>
        <!-- Companies -->

      </div>
    </div>



<!--    <div class="vx-row">-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full">Save Changes</vs-button></div>-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full" color="warning" type="border" @click="revert">Cancel</vs-button></div>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
  import types from '@/models';
  import { productHelpers } from '@/models/helpers';
  import api from '@/http/api';

  export default {
    data() {
      return {
        helpers: productHelpers,
        allGroups: [],
        workingGroups: [],
        productGroups: [],
      }
    },
    props: {
      company: {
        type: types.Company,
        required: true,
      },
      product: {
        type: types.Product,
        required: true,
      },
    },
    watch: {
      company: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.syncWithRemote();
      },
    },
    computed: {
      loaded() {
        if (!this.company || this.company.company_id === 0) return false;
        if (!this.product || this.product.product_id === 0) return false;
        if (this.allGroups.length <= 0) return false;
        // if (this.workingGroups.length <= 0) return false;
        // if (this.productGroups.length <= 0) return false;
        return true;
      }
    },
    methods: {
      async syncWithRemote() {
        if (!this.company || this.company.company_id === 0) return;
        if (!this.product || this.product.product_id === 0) return;
        await Promise.all([
          this.fetchCompanyGroups(),
          this.fetchProductGroups(),
        ]);

        this.revert();
      },
      async fetchCompanyGroups() {
        this.allGroups = await api.fetchCompanyGroups(this.company);
        this.revert();
      },
      async fetchProductGroups() {
        let product = await api.fetchLeanProduct(this.product.product_id, 1);
        if (!product) return;
        this.productGroups = product.company_groups;

      },
      async updateCompanyGroup(item) {
        // this.$vs.loading();

        // persist change
        let success = false;
        if (!item.isSelected) {
          success = await api.deleteProductFromCompanyGroup(this.product.product_id, item.id);
        } else {
          success = await api.addProductToCompanyGroup(this.product.product_id, item.id);
        }

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `${item.division_name} successfully updated` : `Error updating ${item.division_name}`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});


        if (!success) await this.syncWithRemote();

      },
      revert() {
        let temp = JSON.parse(JSON.stringify(this.allGroups));
        temp.forEach((group) => {
          group.isSelected = this.productGroups.filter((prodGroup) => prodGroup.id === group.id).length > 0;
        });
        this.workingGroups = temp;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
